module.exports = __webpack_public_path__ + "img/logo.8db35b0e.png";